/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, ChangeEvent, useContext } from 'react'
import { KTSVG } from '../../_metronic/helpers';
import { Row, Col, Table } from 'react-bootstrap-v5';
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper';
import DataTable from './DataTable'
import BackendTable from 'react-backend-table';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import Chart from "react-apexcharts";
import { AppContext } from '../context/AppContext';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';
import showLoader from "../helpers/ShowLoader"
import { numberFormat } from '../helpers/GlobalHelper';

const DashboardSalesDirector = () => {

	const {currentUser} = useContext(AppContext);
	const [salesOrderNewData, setSalesOrderNewData] = useState({});
	const [dateRange, setDateRange] = useState('year');
	const [leadType, setLeadType] = useState('');
	const [activityType, setActivityType] = useState('');
	const [customDate, setCustomDate] = useState({ customFromDate: '', customToDate: '' });
	const [fromDate, setFromDate] = useState('');
	const [toDate, setToDate] = useState('');

	useEffect(() => {

		if (dateRange === 'custom') {
			setFromDate(customDate.customFromDate);
			setToDate(customDate.customToDate);
		} else if (dateRange === 'year') {
			let date = new Date();
			let year = date.getFullYear();
			setFromDate(year + '-01-01');
			setToDate(year + '-12-31');

		} else if (dateRange === 'month') {
			let date = new Date();
			let year = date.getFullYear();
			let month = date.getMonth() + 1;
			let lastDayOfMonth = new Date(year, month, 0).getDate();
			let monthStr = month < 10 ? '0' + month : month;

			setFromDate(year + '-' + monthStr + '-01');
			setToDate(year + '-' + monthStr + '-' + lastDayOfMonth);
		} else if (dateRange === 'lastMonth') {
			let date = new Date();
			let year = date.getFullYear();
			let month = date.getMonth(); // Subtracting 1 here directly gives last month (0 = Jan, 11 = Dec)

			// Handle if current month is January (month = 0), then last month is December of previous year
			if (month === 0) {
				month = 12;
				year -= 1;
			}

			let monthStr = month < 10 ? '0' + month : month;
			let lastDayOfMonth = new Date(year, month, 0).getDate(); // month here is 1-based for last day calc

			setFromDate(`${year}-${monthStr}-01`);
			setToDate(`${year}-${monthStr}-${lastDayOfMonth}`);
		}

	}, [dateRange, customDate.customFromDate, customDate.customToDate])

	const handleClickLeads = (param: string) => {
		setLeadType(param);
	};

	const handleDateRangeChange = (event: any) => {
		if (event === 'custom') {
			setDateRange('custom');
		} else {
			setDateRange(event.target.value);
		}
	}

	const handleClickActivity = (param: string) => {
		setActivityType(param);
	};

	const [dashboardData, setDashboardData] = useState({
		leadsCreated: 0,
		highPriorityLeads: 0,
		leadsLastThreeDays: 0,
		totalActivity: 0,
		activityLastSevenDays: 0,
		commentLastSevenDays: 0,
		totalSales: 0,
		totalPayment: 0,
		totalDue: 0,
		invoice: 0,
		topSellingProduct: [],
	});

	useEffect(() => {
		getProjectList()
	}, [])

	const [selectProjectOptions, setSelectProjectOptions] = useState([])
	const [project, setProject] = useState({ label: 'Select Project', value: '' });
	const [categories, setCategories] = useState([])
	const [category, setCategory] = useState({ label: 'Select SR Category', value: '' });

	const handleProjectChange = (project: any) => {
		setProject(project)
		getCategories(project.value)
	}

	const handleCategoryChange = (category: any) => {
		setCategory(category);
	}

	useEffect(() => {
		if (selectProjectOptions.length === 1) {
			setProject({ label: selectProjectOptions[0]['label'], value: selectProjectOptions[0]['value'] })
		}
	}, [selectProjectOptions])

	useEffect(() => {
		if (dateRange !== '') {
			options.reloadMyTable();
			getUserDashboard()
		}
	}, [project, category, dateRange])

	const getProjectList = async () => {
		const url = process.env.REACT_APP_API_URL + 'projects';

		const response = await fetch(url, getRequestOptions());

		const data = await response.json();

		data.data.map((element: any) => {
			element.value = element.id_projects;
			element.label = element.project_name;
			return element;
		})

		if (data.data.length === 1) {
			setSelectProjectOptions(data.data)

		} else {
			var allProjectsOpt = [{ id: '', name: '', label: 'All Project', value: '' }]
			let allProjects = data.data.concat(allProjectsOpt);
			setSelectProjectOptions(allProjects);
		}
	}

	const getCategories = async (idProjects: number) => {

		const url = process.env.REACT_APP_API_URL + 'allSrCategory?idProjects=' + idProjects
		const response = await fetch(url, getRequestOptions())
		const data = await response.json()

		data.map((element: any) => {
			element.value = element.id_sr_categories;
			element.label = element.sr_category_name;
			return element;
		})

		var allCategoriesOpt = [{ id: '', name: '', label: 'All', value: '' }]
		let allCategories = data.concat(allCategoriesOpt);
		setCategories(allCategories);

	}

	const getUserDashboard = () => {
		fetch(
			process.env.REACT_APP_API_URL + 'app/dashboard?idProjects=' + project.value + '&idSrCategories=' + category.value + '&type=' + dateRange + '&customFromDate=' + customDate.customFromDate + '&customToDate=' + customDate.customToDate,
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {

				setDashboardData({
					...dashboardData,
					leadsCreated: resp.leadsCreated,
					highPriorityLeads: resp.highPriorityLeads,
					leadsLastThreeDays: resp.leadsLastThreeDays,
					totalActivity: resp.totalActivity,
					activityLastSevenDays: resp.activityLastSevenDays,
					commentLastSevenDays: resp.commentLastSevenDays,
					totalSales: resp.sales.amount,
					totalPayment: resp.collection,
					totalDue: resp.due,
					invoice: resp.invoice,
					topSellingProduct: resp.topSellingProduct,
				});

				const graphSeries = [{
					name: "Sales",
					data: resp.webgraphSalesData
				}]

				if (dateRange === 'year') {
					graphSeries.push({
						name: "Target",
						data: resp.webgraphTargetData
					})
				}

				setChartData({
					options: {
						chart: {
							id: "basic-bar"
						},
						xaxis: {
							categories: resp.webgraphLabel
						},
						yaxis: {
							labels: {
								formatter: function (val: number) {
									return convertToBDAmount(val);
								}
							}
						}
					},
					series: graphSeries,
				})
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	const salesOrderAdditionalPostData = {
		idProjects: project.value,
		idSrCategories: category.value,
		dateRange: dateRange,
		customFromDate: customDate.customFromDate,
		customToDate: customDate.customToDate,
	};

	const expenseColumns = [
		{ title: 'ID', field: 'idAccExpenses', sortable: true, searchable: true, thStyle: { textAlign: "center" }, tdStyle: { textAlign: "center" } },
		{ title: 'Expense Date', field: 'expenseDate', sortable: true, searchable: true },
		{ title: 'Expense Category', field: 'expenseCategory', sortable: true, searchable: true },
		{
			title: 'Requester',
			field: 'userName',
			sortable: true,
			searchable: true,
			hasComponent: true,
			componentValue: ((rowValue: any) => {
				return (
					<>
						{(rowValue.userName) ?? ''}
					</>
				)
			})
		},
		{
			title: 'Project',
			field: 'projectName',
			sortable: true,
			searchable: true,
			hasComponent: true,
			componentValue: ((rowValue: any) => {
				return (
					<>
						{rowValue.projectName ?? ''}
					</>
				)
			})
		},
		{
			title: 'Expense Amount',
			field: 'expenseAmount',
			sortable: false,
			searchable: false,
			tdStyle: { textAlign: "right" },
			hasComponent: true,
			componentValue: ((rowValue: any) => {
				return (
					<>
                        {rowValue.taAmount && <span className='text-muted'>TA Amount: {rowValue.taAmount}</span>}<br/>
                        {rowValue.daAmount && <span className='text-muted'>DA Amount: {rowValue.daAmount}</span>}<br/>
                        {rowValue.otherAmount && <span className='text-muted'>Other Amount: {rowValue.otherAmount}</span>}<br/>
                        {rowValue.expenseAmount && <span className='text-info'>Total Amount: {rowValue.expenseAmount}</span>}<br/>
                    </>
				)
			})
		},
		{
			title: 'This Month Paid Amount',
			field: 'thisMonthPaidAmount',
			sortable: true,
			searchable: true,
			tdStyle: { textAlign: "right" },
			hasComponent: true,
			componentValue: ((rowValue: any) => {
				return (
					<>
						{numberFormat(rowValue.thisMonthPaidAmount)}
					</>
				)
			})
		},
		{
			title: 'Last Month Paid Amount',
			field: 'lastMonthPaidAmount',
			sortable: true,
			searchable: true,
			tdStyle: { textAlign: "right" },
			hasComponent: true,
			componentValue: ((rowValue: any) => {
				return (
					<>
						{numberFormat(rowValue.lastMonthPaidAmount)}
					</>
				)
			})
		},
		{
			title: 'Remarks',
			field: 'remarks',
			sortable: true,
			searchable: true
		},
		
		{
            title: 'Action',
            field: 'idAccExpenses',
            sortable: false,
            searchable: false,
            hasComponent: true,
            componentValue: ((rowValue: any) => {
            
                return (
                    <>
                        {(currentUser?.id_roles === 3 || currentUser?.id_roles === 4 || currentUser?.id_roles === 8) && rowValue.latestStatus==='requested'  && (<button style={{ cursor: "pointer" }} className={'btn btn-info btn-sm'} title='Update Expense Status and Add Remarks' onClick={() => changeStatus(rowValue)}><i className='fa fa-check'></i> Approve/Deny</button>)}
                    </>
                );
            }),
            thStyle: { textAlign: "center", width: "10%" }, tdStyle: { textAlign: "center" }
        },
	]

	const jwt = () => {
		const myToken = localStorage.getItem('MyToken');
		return (myToken != null) ? JSON.parse(myToken) : null;
	}

	let options = {
		title: '',
		url: process.env.REACT_APP_API_URL + 'dashboard/expenses',
		authorization: 'Bearer ' + jwt(),
		perPage: [10, 20, 50, 100, 500],
		orderBy: 'idAccExpenses',
		orderType: 'desc',
		columnSearch: true,
		reloadMyTable: () => { },
		extraData: {
			"idProjects": project.value,
			"dateRange": dateRange,
			"customFromDate": customDate.customFromDate,
			"customToDate": customDate.customToDate,
		}
	}

	const changeStatus = (rowValue: any) => {

		let oldExpenseAmount = (Number(rowValue.taAmount)===0) && (Number(rowValue.daAmount) === 0) && (Number(rowValue.otherAmount) === 0) ? rowValue.expenseAmount : rowValue.otherAmount;
        Swal.fire({
            title: 'Approve or Deny Expense',
            input: 'select',
            inputAttributes: {
                autocapitalize: 'off',
                placeholder: 'Select Status',
                defaultValue: rowValue.latestStatus,
            },
            inputOptions: {
                approved: 'Approved',
                denied: 'Denied',
            },
            inputValue: rowValue.latestStatus,
            html:
            '<div id="amount-fields" style="margin: 15px 0; border-radius: 8px; display: block;">' +
            '<div style="margin-bottom: 10px;">' +
            '<div style="display: flex; align-items: center; gap: 10px; margin-bottom: 8px;">' +
            '<label style="font-weight: 600; color: #2c3e50; font-size: 14px; white-space: nowrap; min-width: 100px;">TA Amount:</label>' +
            '<input type="number" id="ta-amount" class="swal2-input" value="' + (Number(rowValue.taAmount) || 0) + '" step="0.01" min="0" style="margin: 0; border: 2px solid #6c757d; border-radius: 6px; color: #2c3e50; flex: 1;" onchange="calculateTotal()">' +
            '</div>' +
            '<div style="display: flex; align-items: center; gap: 10px; margin-bottom: 8px;">' +
            '<label style="font-weight: 600; color: #2c3e50; font-size: 14px; white-space: nowrap; min-width: 100px;">DA Amount:</label>' +
            '<input type="number" id="da-amount" class="swal2-input" value="' + (Number(rowValue.daAmount) || 0) + '" step="0.01" min="0" style="margin: 0; border: 2px solid #6c757d; border-radius: 6px; color: #2c3e50; flex: 1;" onchange="calculateTotal()">' +
            '</div>' +
            '<div style="display: flex; align-items: center; gap: 10px; margin-bottom: 8px;">' +
            '<label style="font-weight: 600; color: #2c3e50; font-size: 14px; white-space: nowrap; min-width: 100px;">Other Amount:</label>' +
            '<input type="number" id="other-amount" class="swal2-input" value="' + (Number(oldExpenseAmount) || 0) + '" step="0.01" min="0" style="margin: 0; border: 2px solid #6c757d; border-radius: 6px; color: #2c3e50; flex: 1;" onchange="calculateTotal()">' +
            '</div>' +
            '<div style="display: flex; align-items: center; gap: 10px; margin-bottom: 8px;">' +
            '<label style="font-weight: 600; color: #2c3e50; font-size: 14px; white-space: nowrap; min-width: 100px;">Total Amount:</label>' +
            '<input type="number" id="expense-amount" class="swal2-input" value="' + (Number(rowValue.expenseAmount) || 0) + '" readonly style="margin: 0; border: 2px solid #f8f9fa; border-radius: 6px; background-color: #f8f9fa; color: #6c757d; flex: 1;">' +
            '</div>' +
            '</div>' +
            '</div>' +
            '<div style="margin: 15px 0;">' +
            '<div style="display: flex; align-items: flex-start; gap: 10px;">' +
            '<label for="remarks" style="font-weight: 600; color: #2c3e50; font-size: 14px; white-space: nowrap; min-width: 100px; margin-top: 8px;">Remarks:</label>' +
            '<textarea id="remarks" class="swal2-textarea" placeholder="Enter your remarks here..." style="margin: 0; border: 2px solid #6c757d; border-radius: 6px; font-family: inherit; resize: vertical; min-height: 80px; flex: 1;"></textarea>' +
            '</div>' +
            '</div>',
            showCancelButton: true,
            confirmButtonText: 'Submit',
            showLoaderOnConfirm: true,
            didOpen: () => {
                // Add the calculateTotal function to the global scope
                (window as any).calculateTotal = function() {
                    const taAmount = parseFloat((document.getElementById('ta-amount') as HTMLInputElement)?.value || '0');
                    const daAmount = parseFloat((document.getElementById('da-amount') as HTMLInputElement)?.value || '0');
                    const otherAmount = parseFloat((document.getElementById('other-amount') as HTMLInputElement)?.value || '0');
                    const total = taAmount + daAmount + otherAmount;
                    
                    const totalInput = document.getElementById('expense-amount') as HTMLInputElement;
                    if (totalInput) {
                        totalInput.value = total.toFixed(2);
                    }
                };
                
                // Calculate initial total
                setTimeout(() => {
                    (window as any).calculateTotal();
                }, 100);
            },
            preConfirm: (content: any) => {
                const statusInput = Swal.getInput() as unknown as HTMLSelectElement;
                const remarksElement = document.getElementById('remarks') as HTMLTextAreaElement;
                const taAmountElement = document.getElementById('ta-amount') as HTMLInputElement;
                const daAmountElement = document.getElementById('da-amount') as HTMLInputElement;
				const otherAmountElement = document.getElementById('other-amount') as HTMLInputElement;
                const expenseAmountElement = document.getElementById('expense-amount') as HTMLInputElement;
                
                let status = statusInput?.value || '';
                let remarks = remarksElement?.value || '';
                let taAmount = taAmountElement?.value || 0;
                let daAmount = daAmountElement?.value || 0;
				let otherAmount = otherAmountElement?.value || 0;
                let expenseAmount = expenseAmountElement?.value || 0;
                
                let postData: any = { 
                    idAccExpenses: rowValue.idAccExpenses, 
                    status: status, 
                    remarks: remarks,
                    taAmount: parseFloat(taAmount),
                    daAmount: parseFloat(daAmount),
					otherAmount: parseFloat(otherAmount),
                    amount: parseFloat(expenseAmount)
                };
                
                console.log(postData, status, remarks, taAmount, daAmount, expenseAmount);
                updateStatus(postData);
            },
            allowOutsideClick: () => !Swal.isLoading(),
            willClose: () => {
                // Clean up the global function
                delete (window as any).calculateTotal;
            }
        }).then((result) => {
            if (result.isConfirmed) {
                console.log("result.value=", result.value);
            }
        })
    }

    const updateStatus = async (postData: any) => {
        showLoader();
        const requestOptions = postRequestOptions(postData);
        try {
            let response = await fetch(
                `${process.env.REACT_APP_API_URL}expense/update-status`,
                requestOptions
            )
            let respData = await response.json()
            Swal.close();

            if (respData.success === true) {
                toast(<strong>Expense status updated successfully</strong>, { type: 'success', position: 'bottom-right', autoClose: 3000 });
                options.reloadMyTable();
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    html: respData.errorMessage,
                })
            }

        } catch (error) {
            Swal.close();
        }
    }

	const [chartData, setChartData] = useState({
		options: {
			chart: {
				id: "basic-bar"
			},
			xaxis: {
				categories: ['0', '1']
			},
			yaxis: {
				labels: {
					formatter: function (val: number) {
						return convertToBDAmount(val);
					}
				}
			}
		},
		series: [
			{
				name: "Amount",
				data: ['0', '1']
			}
		],

	});

	const handleCustomDateChange = (e: ChangeEvent<HTMLInputElement>) => {
		setCustomDate({ ...customDate, [e.target.name]: e.target.value });
	};

	const showCustomDateData = () => {
		setDateRange('custom')
		options.reloadMyTable();
		getUserDashboard()
	};

	const convertToBDAmount = (label: any) => {
		let labelVal = Number(label);

		if (label < 0) {
			labelVal = label * -1;
		}

		if (labelVal > 10000000) {
			labelVal = (labelVal / 10000000).toFixed(2) + ' Cr';
		}
		if (labelVal > 100000) {
			labelVal = (labelVal / 100000).toFixed(2) + ' Lac';
		}
		if (labelVal > 1000) {
			labelVal = (labelVal / 1000).toFixed(2) + ' K';
		}
		if (label < 0) {
			return '-' + labelVal;
		}
		return labelVal;
	}

	const salesOrderColumns = [
		{ value: 'id', title: 'ID', style: { textAlign: 'center' } },
		{ value: 'salesOrderId', title: 'Sales Order ID', style: { textAlign: 'center' } },
		{ value: 'projectName', title: 'Project', style: { textAlign: 'center' } },
		{ value: 'srName', title: 'SR', style: { textAlign: 'left' } },
		{ value: 'companyName', title: 'Client', style: { textAlign: 'left' } },
		{ value: 'orderDate', title: 'Date', style: { textAlign: 'left' } },
		{
			value: 'orderAmount', title: 'Amount', style: { textAlign: 'center' }, hasHtmlComponent: true, htmlComponent: ((row: any) => {
				return (
					<>{numberFormat(row.orderAmount)}</>
				)
			})
		},
		{ value: 'creditDays', title: 'Credit Days', style: { textAlign: 'left' } },
		{ value: 'createdBy', title: 'Created By', style: { textAlign: 'left' } },
		{
			value: 'action', title: 'Action', style: { textAlign: 'center', whiteSpace: 'nowrap' }, hasActionsComponent: true, actionsComponent: ((row: any) => {
				return (
					<>
						<Link className="btn btn-primary btn-sm" to={`sales-order/${row.idSalesOrders}`}>
							<KTSVG
								path='/media/svg/icons/Layout/Layout-grid.svg'
								className='svg-icon-5 svg-icon'
							/>		Details
						</Link>
						&nbsp;&nbsp;
						<button className="btn btn-primary btn-sm" onClick={() => approveSalesOrder(row.idSalesOrders)}>
							<KTSVG
								path='/media/svg/icons/Navigation/Check.svg'
								className='svg-icon-5 svg-icon'
							/>		Approve
						</button>
						&nbsp;&nbsp;
						<button className="btn btn-primary btn-sm" onClick={() => denySalesOrder(row.idSalesOrders)}>
							<KTSVG
								path='/media/svg/icons/Code/Stop.svg'
								className='svg-icon-5 svg-icon'
							/>		Deny
						</button>
					</>
				)
			})
		}
	]
	const salesOrderFilters = {
		id: {
			filterType: 'like',
			filterValue: '',
		},
		salesOrderId: {
			filterType: 'like',
			filterValue: '',
		},
		projectName: {
			filterType: 'like',
			filterValue: '',
		},
		srName: {
			filterType: 'like',
			filterValue: '',
		},
		companyName: {
			filterType: 'like',
			filterValue: '',
		},
		orderDate: {
			filterType: 'like',
			filterValue: '',
		},
		orderAmount: {
			filterType: 'like',
			filterValue: '',
		},
		creditDays: {
			filterType: 'like',
			filterValue: '',
		},
		createdBy: {
			filterType: 'like',
			filterValue: '',
		},
	}	
	const salesOrderUrl = process.env.REACT_APP_API_URL + 'pending-sales-order/dt'

	const approveSalesOrder = async (idSalesOrders: any) => {
			   
		const confirm = await Swal.fire({
			title: 'Are you sure?',
			text: "You want to Approve this Sales Order?",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#ec008c',
			cancelButtonText: 'Cancel',
			confirmButtonText: 'Yes, Approve it!',
		})
		if (confirm.value) {
			
			try {
				const requestOptions = postRequestOptions({idSalesOrders: idSalesOrders, status: 'Approved'})
				let response = await fetch(
					`${process.env.REACT_APP_API_URL}sales-order/update-status`,
					requestOptions
				)
				let respData = await response.json()
				if (respData.success === true) {
					const successMsg = respData.successMessage
					Swal.fire({
						icon: 'success',
						title: 'Success',
						text: successMsg,
					})   
					setSalesOrderNewData({ id: Date.now() });  
					
				} else {
					Swal.fire({
						icon: 'error',
						title: 'Error',
						html: respData.errors,
					})
				}                    
			} catch (error) {                    
				console.log(error, 'catch the hoop')                    
			}
		}
	}

	const denySalesOrder = async (idSalesOrders: any) => {
			
		const confirm = await Swal.fire({
			title: 'Are you sure?',
			text: "You want to Deny this Sales Order?",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#ec008c',
			cancelButtonText: 'Cancel',
			confirmButtonText: 'Yes, Deny it!',
		})
		if (confirm.value) {
			
			try {
				const requestOptions = postRequestOptions({idSalesOrders: idSalesOrders, status: 'Denied'})
				let response = await fetch(
					`${process.env.REACT_APP_API_URL}sales-order/update-status`,
					requestOptions
				)
				let respData = await response.json()
				if (respData.success === true) {
					const successMsg = respData.successMessage
					Swal.fire({
						icon: 'success',
						title: 'Success',
						text: successMsg,
					})   
					setSalesOrderNewData({ id: Date.now() });      
				} else {
					Swal.fire({
						icon: 'error',
						title: 'Error',
						html: respData.errors,
					})
				}                    
			} catch (error) {                    
				console.log(error, 'catch the hoop')                    
			}
		}
	}

	return (
		<>
			<div style={{ background: "none" }} className='card card-custom'>
				<div className='card-header card-header-stretch overflow-auto'>
					<div className='card-title'>
						<h3 className='card-label'>Sales Director Dashboard</h3>
					</div>
					<div className="card-toolbar">
						<div className='d-flex justify-content-end'>
							<div className='mt-5 mb-2'>
								<select className='form-control' onChange={(event) => handleDateRangeChange(event)}>
									<option value={'year'}>This Year</option>
									<option value={'month'}>This Month</option>
									<option value={'lastMonth'}>Last Month</option>
									<option value={'custom'}>Custom</option>
								</select>
							</div>
							{(dateRange === '' || dateRange === 'custom') &&
								<>
									&nbsp;&nbsp;&nbsp;
									<div className='mt-5 mb-2'>
										<input type='date' className='form-control  form-control-sm' name='customFromDate' onChange={handleCustomDateChange}></input>
									</div>
									&nbsp;&nbsp;&nbsp;
									<div className='mt-5 mb-2'>
										<input type='date' className='form-control  form-control-sm' name='customToDate' onChange={handleCustomDateChange}></input>
									</div>
									&nbsp;&nbsp;&nbsp;
									<div className='mt-5 mb-2'>
										<button className='btn-primary form-control  form-control-sm' name='showCustomData' onClick={showCustomDateData}>Show</button>
									</div>
								</>
							}
							&nbsp;&nbsp;&nbsp;
							{/* {JSON.stringify(customDate, null, 2)} */}
							<div className='mt-5 mb-2'>
								<Select
									// defaultValue={selectProjectOptions}
									onChange={handleProjectChange}
									options={selectProjectOptions}
									placeholder={project.label}
									menuPosition="fixed"
									styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
								/>
							</div>
							&nbsp;&nbsp;&nbsp;
							<div className='mt-5 mb-2'>
								<Select
									// defaultValue={selectProjectOptions}
									onChange={handleCategoryChange}
									options={categories}
									placeholder={category.label}
									menuPosition="fixed"
									styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
								/>
							</div>
						</div>
					</div>
				</div>

				<div className="card-body">

					<div className="row gy-5 g-xl-2">
						<div className='col-10'></div>
						<div className='col-2'>
							{/* <Select
								defaultValue={selectProjectOptions}
								onChange={handleProjectChange}
								options={selectProjectOptions}
								placeholder="Select project"
							/> */}
						</div>
					</div>

					<div className="row gy-5 g-xl-2 mt-4">

						<div className="col-sm-6 col-xl-2 mb-xl-10">
							<div style={{ background: leadType === "lastThreeDays" ? "#f3d6ef82" : "" }} className="card h-lg-100">
								<Link to={`reports?type=orderSheetReport&idProjects=${project.value}&fromDate=${fromDate}&toDate=${toDate}&idSrCategories=${category.value}`}>
									<div className="card-body card-lead d-flex justify-content-between align-items-start flex-column" onClick={() => handleClickLeads('lastThreeDays')}>
										{/* <div className="m-2">
											<KTSVG className='svg-icon-danger svg-icon svg-icon-2' path='/media/svg/icons/Communication/Clipboard-list.svg'></KTSVG>
										</div> */}
										<div className="d-flex flex-column my-4">
											<span className="fw-semibold fs-2x text-gray-800 lh-1 ls-n2">{convertToBDAmount(dashboardData.totalSales)}</span>
											<div className="my-1">
												<span className="fw-semibold fs-4 text-gray-400"> Orders </span>
											</div>
										</div>

									</div>
								</Link>
							</div>
						</div>
						<div className="col-sm-6 col-xl-2 mb-xl-10">
							<div style={{ background: activityType === "lastSevenDays" ? "#bfdde380" : "" }} className="card h-lg-100">
								<Link to={project.value !== '' ? `reports?type=collectionReport&idProjects=${project.value}&fromDate=${fromDate}&toDate=${toDate}` : "#"}
									onClick={(e) => {
										if (project.value === '') e.preventDefault();
									}}>
									<div className="card-body card-activity d-flex justify-content-between align-items-start flex-column" onClick={() => handleClickActivity('lastSevenDays')}>
										{/* <div className="m-2">
										<KTSVG className='svg-icon-success svg-icon svg-icon-2' path='/media/svg/icons/Shopping/Box3.svg'></KTSVG>
									</div> */}
										<div className="d-flex flex-column my-4">
											<span className="fw-semibold fs-2x text-gray-800 lh-1 ls-n2">{convertToBDAmount(dashboardData.totalPayment)}</span>
											<div className="my-1">
												<span className="fw-semibold fs-4 text-gray-400"> Total Payment </span>
											</div>
										</div>
									</div>
								</Link>
							</div>
						</div>
						<div className="col-sm-6 col-xl-2 mb-xl-10">
							<div style={{ background: activityType === "commentsSevenDays" ? "#bfdde380" : "" }} className="card h-lg-100">
								<Link to={`reports?type=dueReport&idProjects=${project.value}&idSrCategories=${category.value}&fromDate=${fromDate}&toDate=${toDate}`}>
									<div className="card-body card-activity d-flex justify-content-between align-items-start flex-column" onClick={() => handleClickActivity('commentsSevenDays')}>

										{/* <div className="m-2">
											<KTSVG className='svg-icon-warning svg-icon svg-icon-2' path='/media/svg/icons/Shopping/Price1.svg'></KTSVG>
										</div> */}
										<div className="d-flex flex-column my-4">
											<span className="fw-semibold fs-2x text-gray-800 lh-1 ls-n2">{convertToBDAmount(dashboardData.totalDue)}</span>
											<div className="my-1">
												<span className="fw-semibold fs-4 text-gray-400"> Total Due </span>
											</div>
										</div>

									</div>
								</Link>
							</div>
						</div>

						<div className="col-sm-6 col-xl-2 mb-xl-10">
							<div className="card h-lg-100">

								<Link to={project.value !== '' ? `reports?type=invoiceHistoryReport&idProjects=${project.value}&fromDate=${fromDate}&toDate=${toDate}` : "#"}
									onClick={(e) => {
										if (project.value === '') e.preventDefault();
									}}>
									<div className="card-body card-lead d-flex justify-content-between align-items-start flex-column" onClick={() => handleClickLeads('')}>
										{/* <div className="m-2">
										<KTSVG className='svg-icon-success svg-icon svg-icon-2' path='/media/svg/icons/Communication/Clipboard-check.svg'></KTSVG>
									</div> */}
										<div className="d-flex flex-column my-4">
											<span className="fw-semibold fs-2x text-gray-800 lh-1 ls-n2">{convertToBDAmount(dashboardData.invoice)}</span>
											<div className="my-1">
												<span className="fw-semibold fs-4 text-gray-400"> Invoice Submitted </span>
											</div>
										</div>
									</div>
								</Link>
							</div>
						</div>
						<div className="col-sm-6 col-xl-2 mb-xl-10">
							<div style={{ background: leadType === "highPriority" ? "#f3d6ef82" : "" }} className="card h-lg-100">
								<div className="card-body card-lead d-flex justify-content-between align-items-start flex-column" onClick={() => handleClickLeads('highPriority')}>
									{/* <div className="m-2">
										<KTSVG className='svg-icon-primary svg-icon svg-icon-2' path='/media/svg/icons/General/Thunder-move.svg'></KTSVG>
									</div> */}
									<div className="d-flex flex-column my-4">
										<span className="fw-semibold fs-2x text-gray-800 lh-1 ls-n2">{dashboardData.highPriorityLeads}</span>
										<div className="my-1">
											<span className="fw-semibold fs-4 text-gray-400"> High Priority Leads </span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-sm-6 col-xl-2 mb-xl-10">
							<div style={{ background: activityType === "" ? "#bfdde380" : "" }} className="card h-lg-100">
								<div className="card-body card-activity d-flex justify-content-between align-items-start flex-column" onClick={() => handleClickActivity('')}>
									{/* <div className="m-2">
										<KTSVG className='svg-icon-info svg-icon svg-icon-2' path='/media/svg/icons/Map/Direction2.svg'></KTSVG>
									</div> */}
									<div className="d-flex flex-column my-4">
										<span className="fw-semibold fs-2x text-gray-800 lh-1 ls-n2">{dashboardData.totalActivity}</span>
										<div className="my-1">
											<span className="fw-semibold fs-4 text-gray-400"> Total Activity </span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<Row className="gy-5 g-xl-2">

						<Col md={12}>
							<div className='card card-custom'>
								<div className='card-header'>
									<div className="card-title">
										<KTSVG path='/media/svg/icons/Text/Bullet-list.svg' className='svg-icon-1 svg-icon-primary' />
										<span className='text fw-bolder' style={{ marginLeft: '10px' }}>
											Pending Sales Order Approval
										</span>
									</div>
									<div className="card-toolbar">
									</div>
								</div>

								<div className='card-body'>
									<DataTable url={salesOrderUrl} columns={salesOrderColumns} filters={salesOrderFilters} additionalPostData={salesOrderAdditionalPostData}  newData={salesOrderNewData} />
								</div>
							</div>
						</Col>

						<Col md={12}>
							<div className='card card-custom'>
								<div className='card-header'>
									<div className="card-title">
										<KTSVG path='/media/svg/icons/Text/Bullet-list.svg' className='svg-icon-1 svg-icon-primary' />
										<span className='text fw-bolder' style={{ marginLeft: '10px' }}>
											List of Expenses Pending Approval
										</span>
									</div>
									<div className="card-toolbar">
									</div>
								</div>

								<div className='card-body'>
									<BackendTable columns={expenseColumns} options={options} />
								</div>
							</div>
						</Col>
						
					</Row>

					<Row className="gy-5 g-xl-2 mb-3">
						<Col md={6}>
							<div className='card card-custom'>
								<div className='card-header'>
									<div className="card-title">
										Sales/Target Analysis
									</div>
								</div>
								<div className='card-body card-scroll h-450px'>
									{/* <pre>{JSON.stringify(chartData, null, 2)}</pre> */}
									<Chart
										options={chartData.options}
										series={chartData.series}
										type="line"
										width="700"
									/>
								</div>
							</div>
						</Col>
						<Col md={6}>
							<div className='card card-custom'>
								<div className='card-header'>
									<div className="card-title">
										Top Selling Products
									</div>
								</div>
								<div className='card-body card-scroll h-450px'>
									{/* <pre>{JSON.stringify(dashboardData.topSellingProduct, null, 2)}</pre> */}
									<Table bordered hover size="sm">
										<thead>

											<tr>
												<th className='text-center'>Product</th>
												<th className='text-center'>Quantity</th>
												<th className='text-center'>Amount</th>
											</tr>
										</thead>
										<tbody>

											{dashboardData.topSellingProduct.map((item: any, index) => {
												return <tr key={'product_' + index}>
													<td>{item.productName + ' ' + item.groupUnitName}</td>
													<td className='text-center'>{Number(item.quantity) + ' ' + item.unitName}</td>
													<td className='text-center'>{convertToBDAmount(item.amount)}</td>
												</tr>
											})}

										</tbody>
									</Table>

								</div>
							</div>
						</Col>
					</Row>
				</div>
			</div >

		</>

	)
}

export default DashboardSalesDirector
